import React from "react";
import FramerWebsite from "../../components/FramerWebsite";

export default function Home() {
  return <FramerWebsite page="/" />;
}
